<template>
  <div class="store-search">
    <form
      @submit="doSearch($event)"
    >
      <div class="styled-input-group">
        <input
          type="text"
          name="q"
          placeholder="Search..."
          :value="searchTerm"
        >
        <button type="submit">
          <svg
            data-icon="search"
            aria-hidden="true"
            viewBox="0 0 32 32"
          >
            <use xlink:href="/resources/app/client/dist/spritemap.svg#sprite-search" />
          </svg>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Search',

  computed: {
    ...mapState([
      'searchTerm'
    ])
  },

  methods: {
    ...mapMutations([
      'setSearch'
    ]),

    doSearch (e) {
      e.preventDefault()

      const searchTerm = e.target.querySelector('input').value

      this.setSearch(searchTerm)
    }
  }
}
</script>
